/* eslint-disable */
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { UploadOutlined } from "@ant-design/icons";
import { message, Upload, Button } from "antd";
// import Button from "@mui/material/Button";
import SUPPORT from "../../Assets/help-desk.png";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { decryptRequest } from "../../utils/crypt";
import { sendQuery } from "../../services/Support";

import "./index.css";

const beforeUpload = (file) => {
  const isSupportedFormat =
    file.type === "application/pdf" ||
    file.type === "application/msword" ||
    file.type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
    file.type === "text/plain" ||
    file.type === "application/vnd.ms-excel" ||
    file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    file.type === "image/jpeg" || // Add image/jpeg
    file.type === "image/png";

  if (!isSupportedFormat) {
    message.error("You can only upload PDF, DOC, TXT, or Excel files!");
  }

  const isLt10M = file.size / 1024 / 1024 < 10;
  if (!isLt10M) {
    message.error("File must be smaller than 10MB!");
  }

  return isSupportedFormat && isLt10M;
};

function Support() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    let token = localStorage.getItem("token");
    var decoded = jwt_decode(token);
    let { encryptedData } = decoded;
    decryptRequest(encryptedData).then((res) => {
      let { name, email } = JSON.parse(res).data;
      setEmail(email);
    });
  }, []);

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleDescriptionChange = (e) => setDescription(e.target.value);

  const handleSubmit = async () => {
    try {
      const fileExtension = fileList[0]?.name.split(".").pop().toLowerCase();
    const fileType =
      fileExtension === "jpg" ||
      fileExtension === "jpeg" ||
      fileExtension === "png"
        ? "image"
        : fileExtension;
    if (description === "") {
      toast("Please Enter Description.");
    } else {
      let emailResponse = await sendQuery({
        email,
        description,
        file: fileList[0]?.url,
        fileType,
      });
      if (emailResponse.message === "Check Your Mail") {
        toast(
          "Your request has been submitted. Check your email for updates from the technical team."
        );
        setDescription("");
        setFileList([]);
      } else {
        toast("Something Went Wrong.");
      }
    }
    } catch (error) {
      console.log(error);
      
    }
    
  };

  const handleChange = (info) => {
    let newFileList = [...info.fileList];
    newFileList = newFileList.map((file) => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });
    setFileList(newFileList);
  };

  const handleRemove = (file) => {
    const updatedFileList = fileList.filter((item) => item.uid !== file.uid);
    setFileList(updatedFileList);
  };

  return (
    <div className="h-1/2 flex justify-center   py-0 px-4">
      <div className="bg-white border border-gray-400 rounded-xl p-8 max-w-xl w-full">
        <h2 className="text-2xl font-semibold text-center text-teal-700 mb-4">
          Support
        </h2>
        <p className="text-gray-600 text-center mb-8">
          If you have any issues, feel free to submit your query and we'll get
          back to you.
        </p>
        <div className="mb-4">
          <label className="block text-teal-700 font-semibold mb-2">
            Description
          </label>
          <textarea
            value={description}
            onChange={handleDescriptionChange}
            className="w-full h-28 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-teal-700 font-semibold mb-2">
            Attachments
          </label>
          <Upload
            name="attachment"
            listType="text"
            action="https://godrej.app-assertai.com:5000/Other/upload-attachment-for-support"
            beforeUpload={beforeUpload}
            onChange={handleChange}
            onRemove={handleRemove}
            fileList={fileList}
          >
            {fileList.length >= 1 ? null : (
              <Button
                variant="primary"
                icon={<UploadOutlined />}
                className="bg-teal-700 text-white hover:bg-teal-600"
              >
                Upload Attachment
              </Button>
            )}
          </Upload>
        </div>

        <div className="flex justify-center">
          <button
            onClick={handleSubmit}
            className="bg-teal-700 text-white font-semibold px-6 py-2 rounded-lg hover:bg-teal-600 transition duration-300"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}

export default Support;
